export default "__VITE_ASSET__DamUUwUH__"